export default {
  listingDetails: {
    id: 'bo_seller.listing.listings_details.listing_details',
    defaultMessage: 'Listing details',
  },
  sku: {
    id: 'bo_seller.listing.listings_details.sku',
    defaultMessage: 'SKU',
  },
  stock: {
    id: 'bo_seller.listing.listings_details.stock',
    defaultMessage: 'Stock',
  },
  required: {
    id: 'bo_seller.listing.listings_details.is_required',
    defaultMessage: 'Required',
  },
  priceError: {
    id: 'bo_seller.listing.listings_details.price_error',
    defaultMessage: 'You need to fill at least one price in the table.',
  },
  mainImageUrl: {
    id: 'bo_seller.listing.listings_details.main_image_url',
    defaultMessage: 'Main Image URL',
  },
  urlImage2: {
    id: 'bo_seller.listing.listings_details.url_image_2',
    defaultMessage: 'URL image 2',
  },
  urlImage3: {
    id: 'bo_seller.listing.listings_details.url_image_3',
    defaultMessage: 'URL image 3',
  },
  urlImage4: {
    id: 'bo_seller.listing.listings_details.url_image_4',
    defaultMessage: 'URL image 4',
  },
  urlImage5: {
    id: 'bo_seller.listing.listings_details.url_image_5',
    defaultMessage: 'URL image 5',
  },
  urlImage6: {
    id: 'bo_seller.listing.listings_details.url_image_6',
    defaultMessage: 'URL image 6',
  },
  alternativeControllerText: {
    id: 'bo_seller.listing.listings_details.alternative_controller_text',
    defaultMessage: 'Controller',
  },
  alternativeCurrentText: {
    id: 'bo_seller.listing.listings_details.alternative_current_text',
    defaultMessage: 'Current slide',
  },
  market: {
    id: 'bo_seller.listing.listings_details.market',
    defaultMessage: 'Market',
  },
  marketWithCurrency: {
    id: 'bo_seller.listing.listings_details.market_with_currency',
    defaultMessage: 'Market ({currency})',
  },
  price: {
    id: 'bo_seller.listing.listings_details.price',
    defaultMessage: 'Price ({currency})',
  },
  priceColumnLabel: {
    id: 'bo_seller.listing.listings_details.price_column_label',
    defaultMessage: 'Price',
  },
  bulkPrice: {
    id: 'bo_seller.listing.listings_details.bulk_price',
    defaultMessage: 'Bulk price',
  },
  selectCurrency: {
    id: 'bo_seller.listing.listings_details.select_currency',
    defaultMessage: 'Select currency',
  },
  enterPrice: {
    id: 'bo_seller.listing.listings_details.enter_price',
    defaultMessage: 'Enter price',
  },
  apply: {
    id: 'bo_seller.listing.listings_details.apply',
    defaultMessage: 'Apply',
  },
  saveDraft: {
    id: 'bo_seller.listing.listings_details.save_draft',
    defaultMessage: 'Save my listing',
  },
  saveDraftAndCreateNewOne: {
    id: 'bo_seller.listing.listings_details.save_draft_and_create_new_one',
    defaultMessage: 'Save my listing and create a new one',
  },
  listingSavedSuccessfully: {
    id: 'bo_seller.listing.listings_details.listing_saved_successfully',
    defaultMessage: 'Listing saved successfully!',
  },
}
